import { BaseController, BaseState } from '../../common/controllers/BaseController';
import { SecondaryNav } from '../../layout/components/SecondaryNav';
import { bind } from '../../common/utils/decorators';
import { t } from 'i18next';
import { Paper, Stack, Typography } from '@mui/material';

type Props = {};

type State = BaseState;

export class UseConditionsStatementController extends BaseController<Props, State> {
  render() {
    return this.renderBase(
      <SecondaryNav title={t('useConditionsStatement.title')} getBreadcrumbs={this.getBreadcrumbs}>
        <Paper sx={{ px: 4.5, py: 5.5 }}>
          <Stack direction="column" gap={1}>
            <Typography variant="body1">{t('useConditionsStatement.text1')}</Typography>
            <Typography variant="body1">{t('useConditionsStatement.text2')}</Typography>
            <Typography variant="body1">{t('useConditionsStatement.text3')}</Typography>
          </Stack>
        </Paper>
      </SecondaryNav>
    );
  }

  @bind
  private getBreadcrumbs() {
    return this.breadcrumbFactory.getUseConditionsStatementBreadcrumbs();
  }
}
